import { FC, useEffect, useContext, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { format } from "date-fns";


import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";

import FooterText from "src/components/footerText";
import CaseVolume from "src/components/manufacturer/caseVolumeLineChart";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";
import CaseFilter from "src/components/manufacturer/statistics";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import { AuthContext } from "../../context/authContext";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import CustomComponentForPriorAuth from "src/components/manufacturer/customComponentPriorAuth";
import CustomPieChart from "src/components/manufacturer/customPieChart";

import {formatStatistics} from "../../helpers";
import { areManFiltersUpdated, getDefaultManFilters } from "src/helpers/manufacturer";
import { GeographicalStatisticsObject, StatisticsApiResponse } from "../manufacturer/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import CustomComponentAreaCaseBySubmission from "src/components/manufacturer/customComponentAreaCaseBySubmission";




const AreaManager: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  const [searchParams, updateSearchParams] = useSearchParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const insuranceName: string | null = params.get('insurance_name');

  const [queryParams, changeQueryParams] = useState(getDefaultManFilters(searchParams, userData, ""));

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);


  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);


  useEffect(() => {
    if (insuranceName) {
      const updatedQueries = {
        ...queryParams,
        insurance_name: insuranceName
      }
      changeQueryParams(updatedQueries)
      getStatsData({}, {}, updatedQueries);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insuranceName]);

  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        type: "index",
        user_id: "",
        insurance_name: "",
        role: "",
      });
    } else {
      changeQueryParams((oldQueryParams) => ({ ...updatedQueries, ...oldQueryParams }));
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = () => {
    const updatedQueries = {
      ...queryParams,

    }
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  return (
    <div className="overflow-y-auto" style={{ backgroundColor: '#cdedfa' }}>
      <div className="container " >
        <AuthMaunfacturerSubHeader />
        {statisticsData && (
          <CaseFilter
            defaultQueryParams={queryParams}
            updateQueryParams={updateQueryParamsAndCallAPI}
            title={`${userData?.name} Statistics`}
          />
        )}
        {statisticsData && (
          <CaseVolume StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData} buttonShows={true} />
        )}
        {statisticsData && (
          <CustomPieChart pieChartObject={statisticsData.data.top_payors} title="Top 10 Payors" />
        )}

        {statisticsData && (
          <div className="row">
            <div className="col p-2">
              <div className="card">
                <div className="card-header">
                  <h5 className="m-0 text-center text-primary">Transfers (vs previous year)
                  </h5>
                </div>
                <div className="card-body">
                  <h6 className="text-center">
                    {formatStatistics(statisticsData.data.transfers_vs_previous_year)}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        )}

        {statisticsData && (
          <CustomComponentForPriorAuth StatisticsObjectType={statisticsData.data} />
        )}

        {statisticsData && (
          <CustomComponentAreaCaseBySubmission 
            StatisticsObjectType={statisticsData.data} title="KAS Reps"
            queryParams={queryParams}
            isFilterObjUpdated={() => areManFiltersUpdated(queryParams, searchParams, userData, "")}
          />
        )}

        {statisticsData?.data && (
          <GeographicalStatistics
            GeographicalStatisticsListType={
              statisticsData?.data
                .geographical_stats as unknown as GeographicalStatisticsObject[]
            }
          />
        )}
        <FooterText footerType="black" />
      </div>
    </div>
  );
};

export default AreaManager;
